import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5657bc41"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-center p-2 fs-8 fw-bolder text-dark"
}
const _hoisted_2 = {
  key: 1,
  class: "d-flex flex-row gap-2 mb-3"
}
const _hoisted_3 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_4 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_5 = {
  key: 0,
  class: "p-3 rounded",
  style: {"box-shadow":"-3px 3px 8px -6px rgba(0,0,0,0.75)","background-color":"#F3F3F3","padding-right":"1rem"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "border text-center p-1 rounded-1",
  style: {"font-size":"12px"}
}, "Mais opções", -1))
const _hoisted_7 = { class: "d-flex flex-row gap-2" }
const _hoisted_8 = { class: "d-flex flex-column w-50" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"12px"} }, "Nome", -1))
const _hoisted_10 = { class: "d-flex flex-column w-50" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"12px"} }, "Valor", -1))
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = { class: "d-flex flex-column" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"12px"} }, "Código", -1))
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"border-bottom":"1px solid gray"},
  class: "pb-4"
}, null, -1))
const _hoisted_17 = { class: "d-flex flex-row gap-2" }
const _hoisted_18 = { class: "d-flex flex-column" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"12px"} }, "Nome", -1))
const _hoisted_20 = { class: "d-flex flex-column" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"12px"} }, "Valor", -1))
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = { class: "d-flex flex-column" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"12px"} }, "Código", -1))
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"border-bottom":"1px solid gray"},
  class: "pb-4"
}, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-plus" }, null, -1))
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Grupo ", -1))
const _hoisted_30 = { key: 2 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nome do kit/revisão ", -1))
const _hoisted_32 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content","font-size":"20px","color":"#ed2b46","padding-top":"4px"},
  class: "m-0 fas fa-search"
}, null, -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Código Mão de Obra", -1))
const _hoisted_36 = { key: 3 }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Preço peça", -1))
const _hoisted_38 = ["disabled"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Preço mão de obra ", -1))
const _hoisted_40 = ["disabled"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tempo mão de obra", -1))
const _hoisted_42 = {
  key: 4,
  style: {"flex-direction":"row","justify-content":"space-between","align-items":"center"}
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Iniciar com marcação?", -1))
const _hoisted_44 = { key: 5 }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "URL imagem", -1))
const _hoisted_46 = { key: 6 }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "URL video", -1))
const _hoisted_48 = { key: 7 }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Descrição", -1))
const _hoisted_50 = { class: "d-flex flex-row gap-4 justify-content-end" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fs-6 fa-trash-alt" }, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Excluir", -1))
const _hoisted_53 = ["disabled"]
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fs-6 fa-save" }, null, -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Salvar", -1))
const _hoisted_56 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_57 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_58 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_59 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_60 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_61 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_62 = ["disabled"]
const _hoisted_63 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_64 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_65 = { style: {"flex-direction":"row","justify-content":"space-between","align-items":"center"} }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Cardápio padrão", -1))
const _hoisted_67 = { style: {"flex-direction":"row","justify-content":"space-between","align-items":"center"} }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Exibir no topo", -1))
const _hoisted_69 = ["disabled"]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tem certeza de que deseja excluir este item?", -1))
const _hoisted_71 = { class: "dialog-footer d-flex flex-row gap-3 justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TitleForm = _resolveComponent("TitleForm")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Button = _resolveComponent("Button")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_money = _resolveDirective("money")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!$setup.productEdit.codAgregados && $props.typeForm === 'addItem')
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Cadastrar"))
      : _createCommentVNode("", true),
    ($props.typeForm === 'itens' || $props.typeForm === 'addItem' )
      ? (_openBlock(), _createElementBlock("form", {
          key: 1,
          onSubmit: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => ($setup.updateOrCreateProduct && $setup.updateOrCreateProduct(...args))),
          name: "form"
        }, [
          _createElementVNode("div", null, [
            ($setup.productEdit.codAgregados !== null)
              ? (_openBlock(), _createBlock(_component_TitleForm, {
                  key: 0,
                  princTitle: $setup.productEdit.tituloDoForm,
                  option1: $props.formItem.dinamico
                }, null, 8, ["princTitle", "option1"]))
              : _createCommentVNode("", true),
            ($setup.productEdit.codAgregados == null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(['w-50 p-1 btn btn-sm btn-light-danger', $setup.tipoItem === 'produtoFixo' ? 'active' : '']),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.tipoItem = 'produtoFixo'))
                  }, "Fixo", 2),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(['w-50 p-1 btn btn-sm btn-light-danger', $setup.tipoItem === 'produtoDinamico' ? 'active' : '']),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.tipoItem = 'produtoDinamico'))
                  }, "Dinâmico", 2)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createElementVNode("span", null, [
                  _createTextVNode("Tipo de Serviço/Produto "),
                  (!$setup.productEdit.dadosExtra && $setup.tipoItem)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, " * "))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_select, {
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (!$setup.productEdit.codAgregados ? $setup.setNomeCardapio(Number($setup.productEdit.dadosExtra)) : null)),
                  disabled: !$setup.tipoItem && !$setup.productEdit.codAgregados,
                  modelValue: $setup.productEdit.dadosExtra,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.productEdit.dadosExtra) = $event)),
                  name: "dadosExtra",
                  filterable: "",
                  class: "w-100",
                  placeholder: "Selecione o tipo"
                }, {
                  default: _withCtx(() => [
                    ($setup.tipoItem === 'produtoDinamico' || !$setup.tipoItem)
                      ? (_openBlock(), _createBlock(_component_el_option_group, {
                          key: 0,
                          label: "Dinâmicos"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.itensDinamicos, (item, key) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                class: "p-2",
                                value: item.codPersonalizacao,
                                label: item.nomePersonalizacao,
                                key: key
                              }, null, 8, ["value", "label"]))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    ($setup.tipoItem === 'produtoFixo' || !$setup.tipoItem)
                      ? (_openBlock(), _createBlock(_component_el_option_group, {
                          key: 1,
                          label: "Fixos"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.itensFixos, (item, key) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                class: "p-2",
                                value: Number(item.codPersonalizacao),
                                label: item.nomePersonalizacao,
                                key: key
                              }, null, 8, ["value", "label"]))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue"])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("span", null, [
                  _createTextVNode("Nome no cardápio "),
                  (!$setup.productEdit.servico && $setup.tipoItem)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, " * "))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_input, {
                  disabled: !$setup.tipoItem && !$setup.productEdit.codAgregados,
                  clearable: "",
                  modelValue: $setup.productEdit.servico,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.productEdit.servico) = $event)),
                  name: "servico",
                  placeholder: "Defina o nome exibido"
                }, null, 8, ["disabled", "modelValue"])
              ]),
              (Number($setup.productEdit.dadosExtra) === 43)
                ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                    _hoisted_6,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.productEdit.itensAgrupados, (item, key) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: key,
                        class: "listaZebra d-flex flex-column gap-2"
                      }, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _hoisted_9,
                            _createVNode(_component_el_input, {
                              clearable: "",
                              modelValue: item.nome,
                              "onUpdate:modelValue": ($event: any) => ((item.nome) = $event),
                              placeholder: "Dados adicionais"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _hoisted_11,
                            _withDirectives(_createElementVNode("input", {
                              id: "inputMoney",
                              clearable: "",
                              "onUpdate:modelValue": ($event: any) => ((item.valorMo) = $event),
                              placeholder: "Dados adicionais"
                            }, null, 8, _hoisted_12), [
                              [_vModelText, item.valorMo],
                              [_directive_money, $setup.CurrencyValueMask]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _hoisted_14,
                          _createVNode(_component_el_input, {
                            clearable: "",
                            modelValue: item.codItemLoja,
                            "onUpdate:modelValue": ($event: any) => ((item.codItemLoja) = $event),
                            placeholder: "Dados adicionais"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-sm btn-light-danger",
                          style: {"font-size":"12px","margin-right":"auto"},
                          onClick: ($event: any) => ($setup.productEdit.itensAgrupados.splice(key, 1))
                        }, "Remover", 8, _hoisted_15),
                        _hoisted_16
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.productEdit.itensAgrupados && $setup.productEdit.itensAgrupados.length ? null : $setup.count, (numb, key) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: key,
                        class: "listaZebra d-flex flex-column gap-2"
                      }, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _hoisted_19,
                            _createVNode(_component_el_input, {
                              clearable: "",
                              modelValue: $setup.productEdit.itensAgrupados[key].nome,
                              "onUpdate:modelValue": ($event: any) => (($setup.productEdit.itensAgrupados[key].nome) = $event),
                              placeholder: "Dados adicionais"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _hoisted_21,
                            _withDirectives(_createElementVNode("input", {
                              id: "inputMoney",
                              clearable: "",
                              "onUpdate:modelValue": ($event: any) => (($setup.productEdit.itensAgrupados[key].valorMo) = $event),
                              placeholder: "Dados adicionais"
                            }, null, 8, _hoisted_22), [
                              [_vModelText, $setup.productEdit.itensAgrupados[key].valorMo],
                              [_directive_money, $setup.CurrencyValueMask]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _hoisted_24,
                          _createVNode(_component_el_input, {
                            clearable: "",
                            modelValue: $setup.productEdit.itensAgrupados[key].codItemLoja,
                            "onUpdate:modelValue": ($event: any) => (($setup.productEdit.itensAgrupados[key].codItemLoja) = $event),
                            placeholder: "Dados adicionais"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-sm btn-light-danger",
                          style: {"font-size":"12px","margin-right":"auto"},
                          onClick: ($event: any) => ($setup.productEdit.itensAgrupados.splice(key, 1))
                        }, "Remover", 8, _hoisted_25),
                        _hoisted_26
                      ]))
                    }), 128)),
                    _createVNode(_component_Button, {
                      class: "ms-auto",
                      type: "button",
                      style: {"width":"max-content"},
                      text: "",
                      onClick: $setup.addItensAgrupados
                    }, {
                      default: _withCtx(() => [
                        _hoisted_27
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (Number($setup.productEdit.dadosExtra) === 44)
                ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                    _hoisted_29,
                    _createVNode(_component_el_select, {
                      modelValue: $setup.productEdit.grupo,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.productEdit.grupo) = $event)),
                      name: "grupo",
                      filterable: "",
                      class: "w-100",
                      placeholder: "Selecione um grupo"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.arrayGrupos, (grupo, key) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            class: "p-2",
                            key: key,
                            label: grupo.grupoExibicao,
                            value: _ctx.grupoExibicao
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (Number($setup.productEdit.dadosExtra) === 206)
                ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                    _hoisted_31,
                    _createVNode(_component_el_input, {
                      modelValue: $setup.productEdit.grupo,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.productEdit.grupo) = $event)),
                      clearable: "",
                      placeholder: "Nome"
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", null, [
                _createElementVNode("span", null, [
                  _createTextVNode("Código "),
                  (!$setup.productEdit.servico && $setup.tipoItem)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, " * "))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_input, {
                  disabled: !$setup.tipoItem && !$setup.productEdit.codAgregados,
                  clearable: "",
                  modelValue: $setup.productEdit.codItemLoja,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.productEdit.codItemLoja) = $event)),
                  id: "codItemLoja",
                  name: "codItemLoja",
                  placeholder: "Código do produto"
                }, {
                  append: _withCtx(() => [
                    _createElementVNode("button", {
                      style: {"background":"none","border":"none"},
                      class: "w-100",
                      type: "button",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.getPropNoEstoque($setup.productEdit.codItemLoja)))
                    }, _hoisted_34)
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue"])
              ]),
              _createElementVNode("li", null, [
                _hoisted_35,
                _createVNode(_component_el_input, {
                  disabled: !$setup.tipoItem && !$setup.productEdit.codAgregados,
                  clearable: "",
                  modelValue: $setup.productEdit.codigoMaoObra,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.productEdit.codigoMaoObra) = $event)),
                  name: "codigoMaoObra",
                  placeholder: "Código mao de obra"
                }, null, 8, ["disabled", "modelValue"])
              ]),
              ($props.formItem.dinamico === 'N' || !$props.formItem.dinamico && $setup.tipoItem !== 'produtoDinamico')
                ? (_openBlock(), _createElementBlock("li", _hoisted_36, [
                    _hoisted_37,
                    _withDirectives(_createElementVNode("input", {
                      id: "inputMoney",
                      disabled: !$setup.tipoItem && !$setup.productEdit.codAgregados,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.productEdit.precoPeca) = $event))
                    }, null, 8, _hoisted_38), [
                      [_vModelText, $setup.productEdit.precoPeca],
                      [_directive_money, $setup.CurrencyValueMask]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", null, [
                _hoisted_39,
                _withDirectives(_createElementVNode("input", {
                  id: "inputMoney",
                  disabled: !$setup.tipoItem && !$setup.productEdit.codAgregados,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.productEdit.valorMaoObra) = $event)),
                  name: "valorMaoObra"
                }, null, 8, _hoisted_40), [
                  [_vModelText, $setup.productEdit.valorMaoObra],
                  [_directive_money, $setup.CurrencyValueMask]
                ])
              ]),
              _createElementVNode("li", null, [
                _hoisted_41,
                _createVNode(_component_el_input, {
                  disabled: !$setup.tipoItem && !$setup.productEdit.codAgregados,
                  clearable: "",
                  modelValue: $setup.productEdit.tempoMaoObra,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.productEdit.tempoMaoObra) = $event)),
                  name: "tempoMaoObra",
                  placeholder: "Defina o tempo"
                }, null, 8, ["disabled", "modelValue"])
              ]),
              ($props.iniciarComMarcacao === 1 && $setup.tipoItem === 'produtoFixo')
                ? (_openBlock(), _createElementBlock("li", _hoisted_42, [
                    _hoisted_43,
                    _createVNode(_component_el_switch, {
                      modelValue: $setup.productEdit.iniciarComMarcacao,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.productEdit.iniciarComMarcacao) = $event)),
                      name: "iniciarComMarcacao",
                      class: "ml-2",
                      "active-value": "S",
                      "inactive-value": "N",
                      style: {"--el-switch-on-color":"#e72f48","--el-switch-off-color":"gray"}
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (Number($setup.productEdit.dadosExtra) === 42)
                ? (_openBlock(), _createElementBlock("li", _hoisted_44, [
                    _hoisted_45,
                    _createVNode(_component_el_input, {
                      placeholder: "Cole a URL",
                      clearable: "",
                      modelValue: $setup.productEdit.imagem,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.productEdit.imagem) = $event)),
                      name: "tempoMaoObra"
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (Number($setup.productEdit.dadosExtra) === 42)
                ? (_openBlock(), _createElementBlock("li", _hoisted_46, [
                    _hoisted_47,
                    _createVNode(_component_el_input, {
                      placeholder: "Cole a URL",
                      clearable: "",
                      modelValue: $setup.productEdit.video,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.productEdit.video) = $event)),
                      name: "tempoMaoObra"
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (Number($setup.productEdit.dadosExtra) === 42)
                ? (_openBlock(), _createElementBlock("li", _hoisted_48, [
                    _hoisted_49,
                    _createVNode(_component_el_input, {
                      placeholder: "Descreva aqui...",
                      type: "textarea",
                      rows: "3",
                      autosize: "",
                      clearable: "",
                      modelValue: $setup.productEdit.descricao,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.productEdit.descricao) = $event)),
                      name: "tempoMaoObra"
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_50, [
            ($setup.productEdit.codAgregados)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-sm btn-danger p-2 d-flex flex-row gap-2 align-items-center",
                  type: "button",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.dialogVisible = true))
                }, [
                  _hoisted_51,
                  _createTextVNode(),
                  _hoisted_52
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              disabled: !$setup.tipoItem && !$setup.productEdit.codAgregados || !$setup.productEdit.servico && !$setup.productEdit.codAgregados || !$setup.productEdit.dadosExtra && !$setup.productEdit.codAgregados,
              class: "btn btn-sm btn-danger p-2 d-flex flex-row gap-2 align-items-center",
              type: "submit"
            }, [
              _hoisted_54,
              _createTextVNode(),
              _hoisted_55
            ], 8, _hoisted_53)
          ])
        ], 32))
      : _createCommentVNode("", true),
    ($props.typeForm === 'configuracaoCardapio')
      ? (_openBlock(), _createElementBlock("form", {
          key: 2,
          onSubmit: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => ($setup.updateOrCreatePacote && $setup.updateOrCreatePacote(...args)))
        }, [
          _createElementVNode("div", null, [
            ($setup.pacoteEdit.tituloDoForm)
              ? (_openBlock(), _createBlock(_component_TitleForm, {
                  key: 0,
                  princTitle: $setup.pacoteEdit.tituloDoForm,
                  option1: null
                }, null, 8, ["princTitle"]))
              : _createCommentVNode("", true),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createElementVNode("span", null, [
                  _createTextVNode("Nome do pacote "),
                  (!$setup.pacoteEdit.descricao && !$setup.pacoteEdit.id)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_56, " * "))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_input, {
                  clearable: "",
                  modelValue: $setup.pacoteEdit.descricao,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.pacoteEdit.descricao) = $event)),
                  name: "servico",
                  placeholder: "Nome do pacote"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("span", null, [
                  _createTextVNode("Juros de % "),
                  (!$setup.pacoteEdit.jurosDe && !$setup.pacoteEdit.id)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_57, " * "))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_input, {
                  clearable: "",
                  modelValue: $setup.pacoteEdit.jurosDe,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.pacoteEdit.jurosDe) = $event)),
                  name: "servico",
                  placeholder: "Digite um valor"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("span", null, [
                  _createTextVNode("Itens fora do Pacote tem Acréscimo de % "),
                  (!$setup.pacoteEdit.acrescimoalacarte && !$setup.pacoteEdit.id)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_58, " * "))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_input, {
                  clearable: "",
                  modelValue: $setup.pacoteEdit.acrescimoalacarte,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.pacoteEdit.acrescimoalacarte) = $event)),
                  name: "servico",
                  placeholder: "Digite um valor"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("span", null, [
                  _createTextVNode("Máximo de Parcelas Exibidas "),
                  (!$setup.pacoteEdit.parcelas && !$setup.pacoteEdit.id)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_59, " * "))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_select, {
                  modelValue: $setup.pacoteEdit.parcelas,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.pacoteEdit.parcelas) = $event)),
                  clearable: "",
                  name: "dadosExtra",
                  filterable: "",
                  class: "w-100",
                  placeholder: "Parcelas"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (item) => {
                      return _createVNode(_component_el_option, {
                        class: "p-2",
                        key: item,
                        label: item,
                        value: item
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("span", null, [
                  _createTextVNode("Parcelas Padrão Marcada: "),
                  (!$setup.pacoteEdit.parcelaPadrao && !$setup.pacoteEdit.id)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_60, " * "))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_select, {
                  modelValue: $setup.pacoteEdit.parcelaPadrao,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (($setup.pacoteEdit.parcelaPadrao) = $event)),
                  clearable: "",
                  name: "dadosExtra",
                  filterable: "",
                  class: "w-100",
                  placeholder: "Parcelas padrão"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pacoteEdit.parcelas ? $setup.pacoteEdit.parcelas : 12, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        class: "p-2",
                        key: item,
                        label: item,
                        value: item
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("span", null, [
                  _createTextVNode("Juros a partir da Parcela "),
                  (!$setup.pacoteEdit.jurosApos && !$setup.pacoteEdit.id)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_61, " * "))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_select, {
                  modelValue: $setup.pacoteEdit.jurosApos,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.pacoteEdit.jurosApos) = $event)),
                  clearable: "",
                  name: "dadosExtra",
                  filterable: "",
                  class: "w-100",
                  placeholder: "Escolha uma parcela"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      class: "p-2",
                      label: 'Sem juros',
                      value: 0
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pacoteEdit.parcelas ? $setup.pacoteEdit.parcelas : 12, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        class: "p-2",
                        key: item,
                        label: item,
                        value: item
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("button", {
            disabled: !$setup.pacoteEdit.descricao && $setup.pacoteEdit.id ||!$setup.pacoteEdit.jurosDe  && !$setup.pacoteEdit.id ||!$setup.pacoteEdit.acrescimoalacarte  && !$setup.pacoteEdit.id ||!$setup.pacoteEdit.parcelas  && !$setup.pacoteEdit.id ||!$setup.pacoteEdit.parcelaPadrao  && !$setup.pacoteEdit.id,
            class: "btn btn-sm btn-danger",
            type: "submit"
          }, " Salvar ", 8, _hoisted_62)
        ], 32))
      : _createCommentVNode("", true),
    ($props.typeForm === 'cardapio')
      ? (_openBlock(), _createElementBlock("form", {
          key: 3,
          onSubmit: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => ($setup.updateOrCreateCardapio && $setup.updateOrCreateCardapio(...args)))
        }, [
          _createElementVNode("div", null, [
            ($setup.cardapioEdit.tituloDoForm)
              ? (_openBlock(), _createBlock(_component_TitleForm, {
                  key: 0,
                  princTitle: $setup.cardapioEdit.tituloDoForm,
                  option1: null
                }, null, 8, ["princTitle"]))
              : _createCommentVNode("", true),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createElementVNode("span", null, [
                  _createTextVNode("Nome do cardápio "),
                  (!$setup.cardapioEdit.nome && !$setup.cardapioEdit.id)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_63, " * "))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_input, {
                  clearable: "",
                  modelValue: $setup.cardapioEdit.nome,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($setup.cardapioEdit.nome) = $event)),
                  name: "servico",
                  placeholder: "Nome do cardápio"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("span", null, [
                  _createTextVNode("Tipo do cardápio "),
                  (!$setup.cardapioEdit.tipoCardapio && !$setup.cardapioEdit.id)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_64, " * "))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_select, {
                  modelValue: $setup.cardapioEdit.tipoCardapio,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (($setup.cardapioEdit.tipoCardapio) = $event)),
                  name: "dadosExtra",
                  filterable: "",
                  class: "w-100",
                  placeholder: "Tipo do cardápio"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      class: "p-2",
                      label: 'Oleo',
                      value: 'Oleo'
                    }),
                    _createVNode(_component_el_option, {
                      class: "p-2",
                      label: 'Pneu',
                      value: 'Pneu'
                    }),
                    _createVNode(_component_el_option, {
                      class: "p-2",
                      label: 'Outros',
                      value: 'Outros'
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("li", _hoisted_65, [
                _hoisted_66,
                _createVNode(_component_el_switch, {
                  modelValue: $setup.cardapioEdit.padrao,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (($setup.cardapioEdit.padrao) = $event)),
                  name: "precoPeca",
                  class: "ml-2",
                  "active-value": "S",
                  "inactive-value": "N",
                  style: {"--el-switch-on-color":"#e72f48","--el-switch-off-color":"gray"}
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("li", _hoisted_67, [
                _hoisted_68,
                _createVNode(_component_el_switch, {
                  modelValue: $setup.cardapioEdit.exibirNoTopo,
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (($setup.cardapioEdit.exibirNoTopo) = $event)),
                  name: "precoPeca",
                  class: "ml-2",
                  "active-value": "S",
                  "inactive-value": "N",
                  style: {"--el-switch-on-color":"#e72f48","--el-switch-off-color":"gray"}
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("button", {
            disabled: !$setup.cardapioEdit.nome && !$setup.cardapioEdit.id || !$setup.cardapioEdit.tipoCardapio && !$setup.cardapioEdit.id,
            class: "btn btn-sm btn-danger",
            type: "submit"
          }, " Salvar ", 8, _hoisted_69)
        ], 32))
      : _createCommentVNode("", true),
    ($setup.dialogVisible && ($props.typeForm === 'itens' ||$props.typeForm === 'addItem' ))
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 4,
          modelValue: $setup.dialogVisible,
          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (($setup.dialogVisible) = $event)),
          title: "Confirme sua ação",
          width: "30%"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_71, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-light-danger",
                onClick: _cache[31] || (_cache[31] = ($event: any) => ($setup.dialogVisible = false))
              }, "Cancelar"),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-light-danger",
                onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.$emit('delete', {dadosExtra: $setup.productEdit.dadosExtra, codAgregados: $setup.productEdit.codAgregados}), $setup.dialogVisible = false))
              }, "Confirmar")
            ])
          ]),
          default: _withCtx(() => [
            _hoisted_70
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}